/** Locale of the page: config → <html lang> → browser → '' (unknown). */
export function detectLocale(configLocale?: string): string {
  if (configLocale) return configLocale
  if (typeof document !== 'undefined') {
    const htmlLang = document.documentElement.lang
    if (htmlLang) return htmlLang
  }
  if (typeof navigator !== 'undefined' && navigator.language) return navigator.language
  return ''
}

/** Value for a locale from a per-locale record: exact (de-AT) → language (de) → fallback. */
export function pickLocale<T>(locale: string, values: Record<string, T> | undefined, fallback: T): T
export function pickLocale<T>(locale: string, values: Record<string, T> | undefined, fallback?: T): T | undefined
export function pickLocale<T>(locale: string, values: Record<string, T> | undefined, fallback?: T): T | undefined {
  if (!values) return fallback
  if (locale && values[locale] !== undefined) return values[locale]
  const prefix = (locale || '').split('-')[0]
  if (prefix && values[prefix] !== undefined) return values[prefix]
  return fallback
}
